import "./Status.scss"
import iconStatusInfo from "assets/img/icon-status-info.svg"
import iconStatusSuccess from "assets/img/icon-status-success.svg"
import iconStatusWarning from "assets/img/icon-status-warning.svg"
import iconStatusCaution from "assets/img/icon-status-caution.svg"
import iconStatusError from "assets/img/icon-status-error.svg"
import iconStatusProhibit from "assets/img/icon-status-prohibit.svg"


import React, { FunctionComponent } from "react"

import { Grid, GridItem } from "components/Grid"

export enum StatusType {
    default = "default",
    success = "success",
    warning = "warning",
    caution = "caution",
    error = "error",
    prohibit = "prohibit",
}

const StatusIcons = {
    [StatusType.default]: iconStatusInfo,
    [StatusType.success]: iconStatusSuccess,
    [StatusType.warning]: iconStatusWarning,
    [StatusType.caution]: iconStatusCaution,
    [StatusType.error]: iconStatusError,
    [StatusType.prohibit]: iconStatusProhibit,
}

interface IStatusProps {
    type?: StatusType,
}

const Status: FunctionComponent<React.PropsWithChildren<IStatusProps>> = ({
    type = "default",
    children,
    ...others
}) => {
    const icon = StatusIcons[type]
    const gridColumns = icon ? "2.4rem auto" : "auto"

    return (
        <div className={`status status--type-${type}`}
            role="alert"
            {...others}>
            <Grid
                columns={gridColumns}
                gap="1.6rem">
                {icon &&
                    <GridItem>
                        <img src={icon} alt="" aria-hidden />
                    </GridItem>
                }
                <GridItem>
                    {children}
                </GridItem>
            </Grid>
        </div>
    )
}

export default Status
